<template>
  <div class="single-setting-wrapper">
    <img v-if="icon" class="icon" :src="icon" />
    <img v-if="warning" class="warning" :src="require('@/assets/_desktop/_settings/_icons/alert_icon.svg')" />
    <div v-if="title" class="setting-title">
      <div>
        {{ title }}
        <span v-if="titleDetails" class="setting-title-details">{{ titleDetails }}</span>
      </div>
    </div>
    <p 
      v-if="description" 
      class="setting-description"
      :class="{red: warning}"
    >{{ description }}</p>

    <div v-if="$slots['custom-styling']" class="slot custom">
      <slot name="custom-styling"></slot>
    </div>
    <div v-else-if="$slots['one-column-no-gaps']" class="slot column">
      <slot name="one-column-no-gaps"></slot>
    </div>
    <div v-else class="slot grid">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    titleDetails: String,
    description: String,
    name: String,
    warning: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.single-setting-wrapper {
  position: relative;
  .warning {
    position: absolute;
    top: -4px;
    left: 20px;
  }
  .setting-title {
    div {
      @include font-rule('averta-bold');
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 0.2px;
      .setting-title-details {
        @include font-rule('averta-bold');
        color: $amethyst;
        line-height: 16px;
        letter-spacing: 0.2px;
      }
    }
  }

  .setting-description {
    @include font-rule('averta-regular');
    font-size: $font-size-caption;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: $amethyst;
    margin-top: 3px;
    margin-bottom: 0;
    &.red {
      color: $red;
    }
  }
}

.single-setting-wrapper {
  max-width: 830px; // 780 + 30 (icon clmn) + 20 (clmn gap)
  display: grid;
  grid-template-columns: 30px auto;
  column-gap: 20px;
  grid-template-rows: auto auto 23px auto; // title description gap content
  //row-gap: 20px;
  .icon {
    grid-row: 1;
    grid-column: 1;
    width: 30px;
    height: 30px;
  }

  .setting-title {
    grid-row: 1;
    grid-column: 2;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .setting-description {
    grid-row: 2;
    grid-column: 2;
    margin-bottom: 12px;
  }

  .slot {
    grid-row: 4;
    grid-column: 2;

    &.custom {
      // styling provided in the parent element
    }

    &.grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 8%;
      grid-auto-rows: auto;
      grid-row-gap: 30px;
    }
    &.column {
      // display: flex;
      // flex-direction: column;
      // align-items: flex-start;
      * {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

@include respond-below(sm) {
  .single-setting-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start; // comment to center horizontally

    .icon {
      margin-bottom: 18px;
    }

    .setting-description {
      margin-top: 14px;
    }

    .slot.grid {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: initial;
      margin-top: 24px;
      grid-row-gap: 0px; // because it's applied on desktop but not on mobiles!
      > div {
        margin-bottom: 30px;

        &:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .slot.column {
      margin-top: 36px;
      width: 100%;
    }
  }
}
</style>
